import { PostEditorReducerFunction, PostEditorSetValidationAction } from '../PostEditorActions';
import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { PostEditorState } from '../../../../models/post-editor';

export const setValidationReducer: PostEditorReducerFunction<PostEditorSetValidationAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { isValid, postGroupErrors } = payload;
  return updateImmutable<PostEditorState>(state, {
    isValid: { $set: isValid },
    shouldValidate: { $set: true },
    postGroups: current =>
      current.map((group, index) =>
        updateImmutable(group, {
          errors: {
            $errorMerge: postGroupErrors[index]
          }
        })
      )
  });
};
